import { render, staticRenderFns } from "./infoForm.vue?vue&type=template&id=226e1ed2&scoped=true"
import script from "./infoForm.vue?vue&type=script&lang=js"
export * from "./infoForm.vue?vue&type=script&lang=js"
import style0 from "./infoForm.vue?vue&type=style&index=0&id=226e1ed2&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226e1ed2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('226e1ed2')) {
      api.createRecord('226e1ed2', component.options)
    } else {
      api.reload('226e1ed2', component.options)
    }
    module.hot.accept("./infoForm.vue?vue&type=template&id=226e1ed2&scoped=true", function () {
      api.rerender('226e1ed2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/hr/infoForm.vue"
export default component.exports